import { render } from "./RequestsTable.vue?vue&type=template&id=39f8eae6&scoped=true"
import script from "./RequestsTable.vue?vue&type=script&lang=js"
export * from "./RequestsTable.vue?vue&type=script&lang=js"

import "./RequestsTable.vue?vue&type=style&index=0&id=39f8eae6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39f8eae6"]])

export default __exports__